export class UserNotification {

  constructor(
    public newItemsCount: number,
    public queryId: number,
    public title: string,
    public filter: string,
    public type: string,
    public pageSize: number
  ) {}
}
